import vehicle from './vehicle'
import user from './user'

export default {
    vehicle,
    userModule: user,
}
